import Vue from "vue";
import Vuex from "vuex";
import { axios2 as axios } from "@/interceptor/useApi";
import Swal from 'sweetalert2';
//import { useApi } from '@/interceptor/useApi'

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    loggedIn: false,
    auth: [],
    //cliente : [],
  },
  getters: {
    loggedIn(state) {
      return state.loggedIn;
    },
  },
  mutations: {
    loggedIn(state) {
      (state.loggedIn = true), localStorage.setItem("logueo", true);
    },
    auth(state, data) {
      state.auth = data;
    },
  },
  actions: {
    messageErrorAlert: function () {
      Swal.fire({
        title: "Upps, algo paso!",
        text: "Servidor desconectado, por favor actualice la ventana!",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#d33",
        confirmButtonText: "Actualizar",
        showClass: {
          popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
        },
        hideClass: {
          popup: `
            animate__animated
            animate__fadeOutDown
            animate__faster
          `,
        },
        backdrop: `
          rgba(255,0,0,0.1)
          left top
          no-repeat
        `,
      }).then((result) => {
        if (result.isConfirmed) {
          location.reload();
        }
      });
    },
    mockLogin(context) {
      context.commit("loggedIn");
    },
    registrocliente: async function ({ commit, dispatch }, datos) {
      try {
        const url = "storeCliente";
        await axios
          .post(url, datos)
          .then((response) => {
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("name", response.data.name);
            localStorage.setItem("razon", response.data.razon);
            localStorage.setItem("id", response.data.id);
            dispatch("mockLogin");
            window.location.reload();

          })
          .catch((error) => {
            this.errorMessage = error.response.data;
            console.error("There was an error!", error);
            dispatch("messageErrorAlert");
          });
      } catch (error) {
        console.log("Error : ", error);
        dispatch("messageErrorAlert");
      }
    },

    ressetpass: async function ({ commit, dispatch }, datos) {
      try {
        //const api = useApi();

        const url = "login/ressetpass";
        const response = await axios.post(url, datos);
        console.log(response);
        // commit("auth", response.data);
        // dispatch("mockLogin");

        // window.location.reload();
        return Promise.resolve(response.data);

      } catch (error) {
        if (error.response.status == 401) {
          return Promise.resolve(error.response.data);
        } else {
          dispatch("messageErrorAlert");
        }
      }
    },
    login: async function ({ commit, dispatch }, datos) {
      try {
        //const api = useApi();

        const url = "login/authenticateSimplified";
        const response = await axios.post(url, datos);

        // Guardar token y datos del usuario
        localStorage.setItem("token", response.data.data.token);
        localStorage.setItem("role", response.data.data.role);
        localStorage.setItem("id", response.data.data.userId);
        localStorage.setItem(
          "name",
          response.data.data.apellidos + " " + response.data.data.nombres
        );
        localStorage.setItem("email", response.data.data.email);

        // Guardar refresh token y fecha de expiración
        if (response.data.data.refresh_token) {
          localStorage.setItem("refresh_token", response.data.data.refresh_token);
        }
        if (response.data.data.expires_at) {
          localStorage.setItem("token_expires_at", response.data.data.expires_at);
        }

        commit("auth", response.data);
        dispatch("mockLogin");

        window.location.reload();
        return Promise.resolve(response.data);

      } catch (error) {
        if (error.response.status == 401) {
          return Promise.resolve(error.response.data);
        } else {
          dispatch("messageErrorAlert");
        }
      }
    },

    refreshToken: async function ({ commit }) {
      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) return null;

        const url = "login/refresh";
        const response = await axios.post(url, { refresh_token: refreshToken });

        // Guardar nuevos tokens
        localStorage.setItem("token", response.data.data.token);
        if (response.data.data.refresh_token) {
          localStorage.setItem("refresh_token", response.data.data.refresh_token);
        }
        if (response.data.data.expires_at) {
          localStorage.setItem("token_expires_at", response.data.data.expires_at);
        }

        return response.data.data.token;

      } catch (error) {
        console.error("Error en refresh proactivo:", error);
        return null;
      }
    },

    logout: async function ({ commit, dispatch }, datos) {
      try {
        // Verificar si el logout es por inactividad
        const logoutReason = sessionStorage.getItem('logout_reason');
        const lastActivity = sessionStorage.getItem('last_activity');

        // Limpiar inmediatamente para evitar que se reutilice en futuros logouts
        sessionStorage.removeItem('logout_reason');
        sessionStorage.removeItem('last_activity');

        if (logoutReason === 'inactivity') {
          // Mostrar modal específico para logout por inactividad con timer
          let timerInterval;
          await Swal.fire({
            title: "Sesión cerrada por inactividad",
            icon: "info",
            html: `Tu sesión se cerró automáticamente después de 7 minutos de inactividad.<br><br>Redirigiendo al login en <b></b> segundos...`,
            timer: 10000, // 10 segundos
            timerProgressBar: true,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
              const b = Swal.getHtmlContainer().querySelector('b');
              timerInterval = setInterval(() => {
                b.textContent = Math.ceil(Swal.getTimerLeft() / 1000);
              }, 100);
            },
            willClose: () => {
              clearInterval(timerInterval);
            }
          });

          // Agregar last_activity a los datos si existe
          if (lastActivity) {
            datos = datos || {};
            datos.last_activity = lastActivity;
          }
        }

        //const api = useApi(); 
        const url = "logout";
        const response = await axios.post(url, datos);

        // Limpiar todo el localStorage y sessionStorage
        localStorage.clear();
        sessionStorage.clear();

        commit("auth", '');

        window.location.reload();

      } catch (error) {
        if (error.response.status == 401) {
          return Promise.resolve(error.response.data);
        } else {
          dispatch("messageErrorAlert");
        }
      }
    },
    sendRecoveryPassword: async function ({ commit, dispatch }, datos) {
      try {
        //const api = useApi();

        const url = "login/send/email";
        const response = await axios.post(url, datos);

        commit("auth", response.data);
        // dispatch("mockLogin");      
        // window.location.reload();
        return Promise.resolve(response.data);

      } catch (error) {
        if (error.response.status == 401) {
          return Promise.resolve(error.response.data);
        } else {
          dispatch("messageErrorAlert");
        }
      }
    },

    updateRecoveryPassword: async function ({ commit, dispatch }, datos) {
      try {
        const url = "login/reset/password";
        const response = await axios.post(url, datos);

        commit("auth", response.data);
        // dispatch("mockLogin");      
        // window.location.reload();
        return Promise.resolve(response.data);

      } catch (error) {
        if (error.response.status == 401) {
          return Promise.resolve(error.response.data);
        } else {
          dispatch("messageErrorAlert");
        }
      }
    },


    // login:async function({commit, dispatch},datos){
    //   try {
    //     const  url = "login/authenticateSimplified"
    //     await axios.post(url,datos)
    //     .then(response => {
    //       /* localStorage.setItem('token',response.data.token)
    //       localStorage.setItem('name',response.data.name)
    //       localStorage.setItem('razon',response.data.razon)
    //       localStorage.setItem('idclient',response.data.id_cliente) */
    //       localStorage.setItem('id',response.data.success.userId)
    //       localStorage.setItem('name',response.data.success.apellidos+' '+response.data.success.nombres)
    //       localStorage.setItem('email',response.data.success.email)
    //       commit('auth',response.data)
    //       dispatch('mockLogin')
    //       window.location.reload();
    //       return Promise.resolve("success");
    //       //router.push('/home')
    //       })
    //     .catch(error => {
    //       this.errorMessage = error.response.data.error;
    //       console.error(this.errorMessage);
    //       return Promise.resolve("error");
    //       //console.error("There was an error!", error);
    //     });

    //   } catch (error) {
    //   }
    // }

    // login: async function ({ commit, dispatch }, datos) {
    //   try {
    //     const url = "login/authenticateSimplified";
    //     const response = await axios.post(url, datos);
    //     /* localStorage.setItem('token',response.data.token)
    //     localStorage.setItem('name',response.data.name)
    //     localStorage.setItem('razon',response.data.razon)
    //     localStorage.setItem('idclient',response.data.id_cliente) */
    //     localStorage.setItem("id", response.data.success.userId);
    //     localStorage.setItem(
    //       "name",
    //       response.data.success.apellidos + " " + response.data.success.nombres
    //     );
    //     localStorage.setItem("email", response.data.success.email);
    //     commit("auth", response.data);
    //     dispatch("mockLogin");
    //     window.location.reload();
    //     //router.push('/home')
    //     return Promise.resolve(true);// promesa resuelta con la respuesta
    //   } catch (error) {
    //     const errorMessage = error.response?.data?.error || "Error desconocido";
    //     console.error(errorMessage);
    //     return Promise.resolve(false);// promesa rechazada con el mensaje de error
    //   }
    // }
  },
};
